/**
 * CPW.Plugin
 * Generic plugins for use across the site
 **/
var CPW = CPW || {};
CPW.Plugins = CPW.Plugins || {};
CPW.Plugins.Browser = CPW.Plugins.Browser || {};

/**
 * CPW.Plugin.smoothScroll.target()
 * @target is id or jQuery element
 * @config (optional) is method to run after animation
 **/
CPW.Plugins.smoothScroll = function( target, config ) {

	var $target = $(target),
		//viewport = CPW.Browser.getViewport(),
		newPosition,
		testPosition,
		dfd = jQuery.Deferred(),
		options = {
			animationTime : 250,										//Speed of animation
			//offsetHeight: (viewport == "mobile") ? 30 : 60,			//Extra spacing to be added to final scroll position
			offsetHeight: 0,
			side : 'top',												//Position of the element to scroll to
			isInView: false												//Check to see if the element is within browser viewport
		};

	$.extend( options, config );

	//Check: If element does not exist then quit
	if (!$target.length)  {
		return dfd.reject().promise();
	}

	var targetTop = $target.offset().top,
		targetBottom = targetTop + $target.outerHeight(),
		pageTop = $(window).scrollTop(),
		pageHeight = $(window).height(),
		headerheight = document.getElementById("Search_nav").clientHeight,
		pageBottom = pageTop + pageHeight;

	//Check: is element already visible within page then quit.
	if (options.isInView) {
		testPosition = (options.side == 'top') ? targetTop : targetBottom;
		testPosition = testPosition - headerheight;
		if (testPosition > pageTop && testPosition < pageBottom) {
			return dfd.reject().promise();
		}
	}

	//Set new position. Not needed yet
	if (options.side == 'bottom') {
		newPosition = (targetBottom - pageHeight) + options.offsetHeight;
	} else {
		//default: top
		newPosition = targetTop - headerheight - options.offsetHeight;
	}
	

	//If element is not fully in viewport
	if (newPosition) {
		$("html,body").stop().animate({ scrollTop: newPosition }, options.animationTime );
	}

	return dfd.resolve().promise();
}

CPW.Plugins.lazyLoad = function( target ) {
	var $img = $(target).is('img[data-src]') ? $(target) : $(target).find('img[data-src]');
	$img.each(function(i){ 
		var src = $(this).data('src');
		$(this).attr('src' , src);
		$(this).removeAttr('data-src');
	})
}

//attempt to handle redirection of simple urls and hash tags
CPW.Plugins.Browser.redirect = function(url) {
	var loc = window.location.pathname;
    var hashParam = window.location.hash;
    if(hashParam.indexOf('#') > -1){
		hashParam = hashParam.split('#')[1];
    }
    var fintxt = url;
    var newHash = '';
    if(fintxt.indexOf('#') > -1){
        newHash = fintxt.split('#')[1];
		fintxt = fintxt.split(".html")[0]+'.html';
    }

    window.location.href = url;
	if(!!newHash && loc == fintxt && hashParam != newHash) setTimeout(function(){window.location.reload();}, 100);
}